/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_SALARIE(state, formateurs) {
    state.formateur_s = formateurs
  },
  ADD_ITEM(state, item) {
    state.users.unshift(item)
  },
  SET_USERS(state, users) {
    state.users = users
  },
  SET_FORMATIONS(state, formations) {
    state.formations = formations
  },
  REMOVE_RECORD(state, itemId) {
      const userIndex = state.users.findIndex((u) => u.id == itemId)
      state.users.splice(userIndex, 1)
  },
  UPDATE_USERS(state, user) {
    const eventIndex = state.users.findIndex((e) => e.id == user.id)
    Object.assign(state.users[eventIndex], user)
},
}
